import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import $ from 'jquery/dist/jquery';
import _ from 'underscore';

import { webApiConfig } from 'src/config';

const path = {
  1: '/common/top',
  '2-1': '/common/customer_notifications',
  '3-1': '/common/documents',
  '4-1': '/common/accounts',
  '4-2': '/common/accounts/new',
  '5-1': '/common/personal_informations',
  '5-2': '/common/personal_informations/new',
  '6-1': '/common/group_numbers'
};

const currentPathKey = (location) => {
  const result = Object.keys(path).filter((k) => {
    return path[k] == location;
  })[0];
  if (result) {
    return result;
  } else {
    switch (location.split('/')[3]) {
      default:
        return '1';
        break;
    }
  }
};

const genDefaultOpenKeys = (key) => {
  const defaultOpenKeys = [];
  const array = key.split('-');
  for (let i = array.length; i > 0; i -= 1) {
    defaultOpenKeys.push(array.join('-'));
    array.pop();
  }
  return defaultOpenKeys;
};

const NavBar = () => {
  const location = useLocation();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([
    currentPathKey(location.pathname)
  ]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState(
    genDefaultOpenKeys(currentPathKey(location.pathname))
  );
  const [disabledMenus, setDisabledMenus] = useState({
    account: {
      index: true,
      create: true
    },
    personal_information: {
      index: true,
      create: true
    },
    group_number: {
      index: true
    },
    customer_notification: {
      index: true
    },
    document: {
      index: true
    }
  });

  useEffect(() => {
    let isMounted = true;

    const _setDisabledMenus = async () => {
      const accessToken = await getAccessTokenSilently();
      let results = await $.ajax({
        url: `${webApiConfig.baseUri.bff}/common/accounts/abilities`,
        type: 'GET',
        async: false,
        dataType: 'json',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
        }
      }).responseText;
      results = results ? JSON.parse(results) : [];
      const newDisabledMenus = disabledMenus;
      _.keys(results).forEach((domain) => {
        results[domain].forEach((ability) => {
          if (disabledMenus[domain]) {
            newDisabledMenus[domain][ability] = false;
          }
        });
      });
      if (isMounted) {
        setDisabledMenus({ ...disabledMenus, ...newDisabledMenus });
      }
    };

    _setDisabledMenus();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDefaultSelectedKeys([currentPathKey(location.pathname)]);
      setDefaultOpenKeys(genDefaultOpenKeys(currentPathKey(location.pathname)));
    }

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  const onClick = (info) => {
    history.push(path[info.key]);
  };

  const onTitleClick = (info) => {
    if (defaultOpenKeys.find((key) => key === info.key)) {
      const newKeys = defaultOpenKeys.filter((key) => key !== info.key);
      setDefaultOpenKeys(newKeys);
    } else {
      setDefaultOpenKeys([...defaultOpenKeys, info.key]);
    }
  };
  return (
    <div>
      <div>
        <Menu
          onClick={onClick}
          mode="inline"
          selectedKeys={defaultSelectedKeys}
          openKeys={defaultOpenKeys}
        >
          <MenuItem key="1">ホーム</MenuItem>
          <SubMenu key="2" title="トピック" onTitleClick={onTitleClick}>
            <MenuItem
              key="2-1"
              disabled={disabledMenus.customer_notification.index}
            >
              一覧
            </MenuItem>
          </SubMenu>
          <SubMenu key="3" title="ドキュメント" onTitleClick={onTitleClick}>
            <MenuItem key="3-1" disabled={disabledMenus.document.index}>
              一覧
            </MenuItem>
          </SubMenu>
          <SubMenu key="4" title="ユーザー" onTitleClick={onTitleClick}>
            <MenuItem key="4-1" disabled={disabledMenus.account.index}>
              一覧
            </MenuItem>
            <MenuItem key="4-2" disabled={disabledMenus.account.create}>
              登録
            </MenuItem>
          </SubMenu>
          <SubMenu key="5" title="通知先" onTitleClick={onTitleClick}>
            <MenuItem
              key="5-1"
              disabled={disabledMenus.personal_information.index}
            >
              一覧
            </MenuItem>
            <MenuItem
              key="5-2"
              disabled={disabledMenus.personal_information.create}
            >
              登録
            </MenuItem>
          </SubMenu>
          <SubMenu
            key="6"
            title="サービスグループ(PID)"
            onTitleClick={onTitleClick}
          >
            <MenuItem key="6-1" disabled={disabledMenus.group_number.index}>
              一覧
            </MenuItem>
          </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

export default NavBar;
